import { compatWrapper } from '@backstage/core-compat-api';
import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const componentFilter = (entity: { kind: string }) =>
  entity.kind.toLocaleLowerCase('en-US') === 'component';

export const anderCicdContent = EntityContentBlueprint.make({
  name: 'cicd',
  params: {
    path: 'cicd',
    title: 'CI/CD',
    filter: componentFilter,
    loader: async () =>
      import('./AnderCicdContent').then(module =>
        compatWrapper(<module.AnderCicdContent />),
      ),
  },
});

export const anderReleasesContent = EntityContentBlueprint.make({
  name: 'releases',
  params: {
    path: 'releases',
    title: 'Releases',
    filter: componentFilter,
    loader: async () =>
      import('./AnderCicdContent').then(module =>
        compatWrapper(<module.AnderReleasesContent />),
      ),
  },
});

export const anderCicdModule = createFrontendPlugin({
  pluginId: 'ander-cicd',
  extensions: [anderCicdContent, anderReleasesContent],
});
